import React from 'react';
import { Typography } from "@material-tailwind/react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-regular-svg-icons';
import { PlusCircleIcon, TrashIcon } from '@heroicons/react/24/outline';
import { Field } from 'formik';
import { transformarIso8601 } from '../../Helpers/fechas';

const formatearFechaEntrega = (fecha) => {
    if (!fecha) {
        return '-';
    }

    if (/^\d{2}\/\d{2}\/\d{4}$/.test(fecha)) {
        return fecha;
    }

    if (/^\d{4}-\d{2}-\d{2}$/.test(fecha)) {
        return fecha.split('-').reverse().join('/');
    }

    return transformarIso8601(fecha);
};

export const TabDatosContables = (props) => {
    const { 
        values, handleChange, setFieldValue, esVisualizacion,
        balances, handleEliminarBalance,
        periodosBalance,
        nuevoBalancePeriodo, setNuevoBalancePeriodo, nuevoBalanceFecha, setNuevoBalanceFecha, handleAgregarBalance,
        diezmos,
        nuevoMinistroSeleccionado, setNuevoMinistroSeleccionado, obrerosUad, handleAgregarMinistroInfo, ministrosDependientes, handleEliminarMinistroInfo,
        cuentasBancarias, setCuentaActiva, cuentaActiva, handleEliminarCuentaBancaria, bancosList, tiposCuentasList, handleGuardarCuentaBancaria, handleFirmanteChange
    } = props;

    return (

        <div className="bg-white p-5 rounded-md text-sm">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                {/* Left Column: Balances */}
                <div className="flex flex-col gap-6">
                    <div className="flex flex-col">
                        <Typography variant="small" color="blue-gray" className="mb-3 font-semibold uppercase tracking-wider text-xs">
                            Balances presentados
                        </Typography>
                        
                        <div className="border border-gray-200 rounded-md overflow-hidden bg-white shadow-sm w-full">
                            <table className="w-full text-left text-sm border-collapse">
                                <thead>
                                    <tr className="bg-gray-50 border-b border-gray-200">
                                        <th className="px-4 py-3 font-semibold text-gray-700 w-1/2">Período</th>
                                        <th className="px-4 py-3 font-semibold text-gray-700 w-1/2">Fecha de entrega</th>
                                        { !esVisualizacion && <th className="px-4 py-3 w-12 text-center text-gray-700">Acción</th> }
                                    </tr>
                                </thead>
                                <tbody>
                                    {balances && balances.length > 0 ? (
                                        balances.map((item, idx) => (
                                            <tr key={idx} className="border-b border-gray-100 last:border-b-0 hover:bg-blue-50 transition-colors">
                                                <td className="px-4 py-3 text-gray-800">{item.periodo}</td>
                                                <td className="px-4 py-3 text-gray-600">{formatearFechaEntrega(item.f_entrega)}</td>
                                                {!esVisualizacion && <td className="px-4 py-3 text-center">
                                                    <button type="button" title="Eliminar balance" onClick={() => handleEliminarBalance(item)} className="text-red-400 hover:text-red-600 transition-colors p-1 rounded-full hover:bg-red-50">
                                                        <TrashIcon width={20} height={20} />
                                                    </button>
                                                </td>}
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={esVisualizacion ? "2" : "3"} className="px-4 py-8 text-center text-gray-400 italic">No hay balances registrados</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* Add Balance Form */}
                    {!esVisualizacion && (
                        <div className="p-5 bg-gray-50 border border-gray-200 rounded-md shadow-sm w-full">
                            <Typography variant="small" color="blue-gray" className="mb-3 font-semibold text-xs tracking-wider uppercase text-gray-700">
                                Añadir nuevo balance
                            </Typography>
                            <div className="flex flex-col sm:flex-row items-end gap-4 w-full">
                                <div className="flex flex-col flex-1 w-full relative">
                                    <label className="text-xs font-semibold text-gray-600 mb-1">Período</label>
                                    <div className="relative">
                                        <select 
                                            className="iglesia-form-control appearance-none" 
                                            disabled={esVisualizacion} 
                                            value={nuevoBalancePeriodo} 
                                            onChange={(e) => setNuevoBalancePeriodo(e.target.value)}
                                        >
                                            <option value="">Seleccione un período...</option>
                                            {periodosBalance?.map(periodo => (
                                                <option
                                                    key={periodo.id_año_fiscal}
                                                    value={periodo.id_año_fiscal}
                                                >
                                                    {periodo.nombre}
                                                </option>
                                            ))}
                                        </select>
                                        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-600">
                                            <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex flex-col flex-1 w-full">
                                    <label className="text-xs font-semibold text-gray-600 mb-1">Fecha de Presentación</label>
                                    <input 
                                        type="date" 
                                        className="iglesia-form-control" 
                                        disabled={esVisualizacion} 
                                        value={nuevoBalanceFecha} 
                                        onChange={(e) => setNuevoBalanceFecha(e.target.value)} 
                                    />
                                </div>
                                <button 
                                    type="button" 
                                    onClick={handleAgregarBalance} 
                                    disabled={!nuevoBalancePeriodo || !nuevoBalanceFecha}
                                    className={`h-[42px] px-4 rounded-md font-semibold text-white transition-all flex items-center justify-center min-w-[50px] ${(!nuevoBalancePeriodo || !nuevoBalanceFecha) ? 'bg-green-300 cursor-not-allowed hidden sm:flex' : 'bg-green-500 hover:bg-green-600 shadow-md w-full sm:w-auto'}`}
                                    title="Agregar balance"
                                >
                                    <span className="sm:hidden mr-2">Agregar Balance</span>
                                    AGREGAR
                                </button>
                            </div>
                        </div>
                    )}

                    {/* Meses diezmados */}
                    <div className="flex flex-col">
                        <Typography variant="small" color="blue-gray" className="mb-3 font-semibold uppercase tracking-wider text-xs">
                            Meses diezmados
                        </Typography>
                        {diezmos && diezmos.length > 0 ? (
                            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
                                {diezmos.map((item, idx) => (
                                    <div
                                        key={idx}
                                        className={`p-3 rounded-lg text-center font-medium shadow-sm border text-sm ${Number(item.diezmo) > 0 ? 'bg-blue-50 text-blue-700 border-blue-200' : 'bg-red-50 text-red-600 border-red-200'}`}
                                    >
                                        {item.periodo}
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="border border-gray-200 rounded-md bg-white shadow-sm px-4 py-8 text-center text-gray-400 italic">
                                No hay meses diezmados registrados
                            </div>
                        )}
                    </div>
                </div>

                {/* Right Column: Acta & Otros */}
                <div className="flex flex-col gap-6">
                    {/* Acta de Afiliacion */}
                    <div className="p-5 bg-gray-50 border border-gray-200 rounded-md shadow-sm">
                        <Typography variant="small" color="blue-gray" className="mb-4 font-semibold uppercase tracking-wider text-xs border-b border-gray-200 pb-2">
                            Acta de afiliación
                        </Typography>
                        
                        <div className="flex flex-col gap-4">
                            <div className="flex flex-col">
                                <label htmlFor="abm-acta_afiliacion" className="text-xs font-semibold text-gray-600 mb-1">Nro. de Acta de afiliación</label>
                                <Field 
                                    name="acta_afiliacion" 
                                    type="text" 
                                    maxLength="50" 
                                    disabled={esVisualizacion} 
                                    id="abm-acta_afiliacion" 
                                    placeholder="Ingrese el número de acta"
                                    className="iglesia-form-control" 
                                />
                            </div>

                            <div className="flex flex-col">
                                <label htmlFor="abm-f_pres_acta_afil" className="text-xs font-semibold text-gray-600 mb-1">Fecha presentación de acta</label>
                                <input
                                    name="f_pres_acta_afil"
                                    type="date"
                                    value={values.f_pres_acta_afil ? values.f_pres_acta_afil.substring(0, 10) : ''}
                                    onChange={handleChange}
                                    disabled={esVisualizacion || !values.activar_f_pres_acta}
                                    id="abm-f_pres_acta_afil"
                                    className={`iglesia-form-control ${(!values.activar_f_pres_acta || esVisualizacion) ? 'bg-gray-100 text-gray-500 cursor-not-allowed' : ''}`}
                                />
                            </div>

                            <div className="flex items-center mt-1 bg-white p-3 border border-gray-200 rounded-md cursor-pointer hover:bg-gray-50 transition-colors" onClick={(e) => { if(!esVisualizacion) { document.getElementById('abm-activar_f_pres_acta').click(); } }}>
                                <Field id="abm-activar_f_pres_acta" type="checkbox" disabled={esVisualizacion} name="activar_f_pres_acta" className="w-5 h-5 mr-3 rounded border-gray-300 text-blue-500 focus:ring-blue-500 cursor-pointer pointer-events-none" />
                                <label htmlFor="abm-activar_f_pres_acta" className="text-sm font-medium text-gray-700 cursor-pointer pointer-events-none">Habilitar fecha de presentación</label>
                            </div>
                        </div>
                    </div>

                    {/* Otros */}
                    <div className="p-5 bg-gray-50 border border-gray-200 rounded-md shadow-sm">
                        <Typography variant="small" color="blue-gray" className="mb-4 font-semibold uppercase tracking-wider text-xs border-b border-gray-200 pb-2">
                            Configuraciones adicionales
                        </Typography>
                        
                        <div className="flex items-center bg-white p-3 border border-gray-200 rounded-md cursor-pointer hover:bg-gray-50 transition-colors" onClick={(e) => { if(!esVisualizacion) { document.getElementById('abm-eximida_diezmos').click(); } }}>
                            <Field id="abm-eximida_diezmos" type="checkbox" disabled={esVisualizacion} name="eximida_diezmos" className="w-5 h-5 mr-3 rounded border-gray-300 text-blue-500 focus:ring-blue-500 cursor-pointer pointer-events-none" />
                            <label htmlFor="abm-eximida_diezmos" className="text-sm font-medium text-gray-700 cursor-pointer pointer-events-none">Iglesia eximida de pago de diezmos</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
    );
};
